/* eslint-disable */
import { useDispatch } from 'react-redux';
import { useMultiplePo } from './contexts/MultiplePoContext';
import MultiPoContent from './multiPoContent';
import { modalActions } from '@/Actions';
import { BaseModal } from '../BaseModal';
import { Button } from '@/Components/ui/button';
import { getHigherUnitName, getHigherUnitAndQuantity } from '@/Helpers';
import AddProductModal from './AddProductModal';
import { buttonConfig } from './config/buttonConfig';
import ConfirmationModal from './ConfirmationModal';
import { useEffect, useRef, useState } from 'react';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { notificationServices } from '@/Services';
import { ProductionPlanModal } from '../ProductionPlanModal';
import { urls } from '@/Constants';
import moment from 'moment';
import { parseData } from './clipboardUtils';
import Heading from './Heading';
import { Trash2, CheckCheck, ArrowLeft, RefreshCw } from 'lucide-react';
import { transformLongTermPlanApiResponse } from './utils/utils';
import productionPlanServices from '@/Services/Analytics Services/production-plan.services';
import { CustomModal } from '../CustomModal';
import { staticTableTransformers } from './config/tableStaticConfig';
import { useAuth } from '@/Components/Auth/Login/auth';

// Icon map for button icons
const iconMap = {
	reset: Trash2,
	check: CheckCheck,
	arrowLeft: ArrowLeft,
	refresh: RefreshCw,
};

const BaseMultipleModal = (props) => {
	const {
		mode = {},
		openModal = false,
		modeName = '',
		navSelectedStore = {},
	} = props;
	const toggleModal = useDispatch();
	const { appConfig = {}, userConfig = {} } = useAuth();
	const { configs = {} } = appConfig || {};
	const customerId = appConfig?.customerId;
	const productionPlanModal = useDispatch();
	const {
		dispatch,
		state,
		tableData,
		lists,
		setLists,
		ppId,
		changeQtyRef,
		productList,
		batches,
		selectedPOs,
		setTableData,
		editMode,
		viewMode,
		storeList,
		prevTableData,
		setPrevTableData,
		initialTableData,
		initialFieldsData,
		initialStateSet,
		originalRowsRef,
		setSearchQuery,
		workerAllocations,
		setWorkerAllocations,
		setSortColumn,
		setSortType,
		orderwise,
	} = useMultiplePo();
	const [confirmationModal, setConfirmationModal] = useState({
		isOpen: false,
		message: '',
		heading: '',
		isAlert: false,
		alertType: 'info',
		handleCloseConfirmation: () => {
			setConfirmationModal({
				isOpen: false,
				message: '',
				heading: '',
				isAlert: false,
				alertType: 'info',
			});
		},
		handleConfirmSave: () => {
			setConfirmationModal({
				isOpen: false,
				message: '',
				heading: '',
				isAlert: false,
				alertType: 'info',
			});
		},
		customButton: [],
		showCrossBtn: false,
		isLoading: false,
	});
	const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);

	const handleClose = () => {
		dispatch({
			type: 'RESET',
		});
		setTableData({
			headers: [],
			rows: [],
		});
		setPrevTableData({});
		setLists({});
		changeQtyRef.current = true;
		setConfirmationModal({
			isOpen: false,
			message: '',
			heading: '',
			isAlert: false,
			alertType: 'info',
			isLoading: false,
		});
		initialStateSet.current = false;
		toggleModal(modalActions?.toggleMultiplePoModal(false));
		setWorkerAllocations({});
		originalRowsRef.current = null;
		setSortColumn(null);
		setSortType(null);
	};

	useEffect(() => {
		if (Object.values(navSelectedStore)?.length > 0) {
			dispatch({
				type: 'SET_STATE',
				payload: { ...navSelectedStore },
			});
		}
	}, [navSelectedStore]);

	// Generic initial data handler for modes that pass table data directly (e.g., longTermProduction edit)
	useEffect(() => {
		if (initialTableData?.headers && initialTableData?.rows && editMode) {
			setTableData(initialTableData);
		}
		if (initialFieldsData && editMode) {
			dispatch({
				type: 'SET_STATE',
				payload: initialFieldsData,
			});
			if (initialFieldsData.workerAllocations) {
				setWorkerAllocations(initialFieldsData.workerAllocations);
			}
		}
	}, [initialTableData, initialFieldsData, editMode]);

	// Edit/View mode for modes using selectedPOs (order, dataEntry)
	useEffect(() => {
		if (
			(editMode || viewMode) &&
			lists?.storeList?.length > 0 &&
			selectedPOs?.length > 0
		) {
			if (orderwise) {
				const transformer = staticTableTransformers.orderWiseEdit;
				const { headers, rows } = transformer
					? transformer(
						mode,
						productList,
						batches,
						state,
						lists,
						selectedPOs
					)
					: { headers: [], rows: [] };
				const fromStoreId = selectedPOs[0]?.fromStore;
				const filteredStoreList = fromStoreId
					? lists?.storeList?.filter(
						(store) => store?.parentStore === fromStoreId
					)
					: lists?.storeList;
				const { fieldsData } = parseData(
					selectedPOs,
					filteredStoreList,
					productList,
					viewMode
				);

				const initialOrderInfo = {};
				selectedPOs.forEach((po) => {
					initialOrderInfo[po.id] = {
						isPriority: po.priority || false,
					};
				});
				dispatch({
					type: 'SET_STATE',
					payload: {
						...fieldsData,
						orderInfo: initialOrderInfo,
					},
				});

				setTableData({
					headers,
					rows,
				});
			} else {
				const fromStoreId = selectedPOs[0]?.fromStore;
				const filteredStoreList = fromStoreId
					? lists?.storeList?.filter(
						(store) => store?.parentStore === fromStoreId
					)
					: lists?.storeList;
				storeList.current = filteredStoreList;

				const { headers, rows, fieldsData } = parseData(
					selectedPOs,
					filteredStoreList,
					productList,
					viewMode
				);
				dispatch({
					type: 'SET_STATE',
					payload: fieldsData,
				});
				setTableData({
					headers: viewMode
						? headers?.filter((item) => item?.id !== 'Actions')
						: headers,
					rows: rows,
				});
			}
		}
	}, [editMode, viewMode, lists?.storeList, selectedPOs, orderwise]);

	const proceedGenerateProductionPlan = async (orderData = []) => {
		const idsList = orderData?.map((item) => item?.id);
		const req = {
			data: {
				poIds: idsList,
				storeId: state?.fromStore,
				date: moment(state?.expectedDeliveryDate).format('YYYY-MM-DD'),
			},
		};
		try {
			const response =
				await inventoryAnalyticsServices.fetchProductionPlan(req);
			if (response?.statusCode === 200) {
				productionPlanModal(
					modalActions?.toggleProductionPlanModal(true, {
						idsList,
						storeId: state?.fromStore,
						date: moment(state?.expectedDeliveryDate).format(
							'YYYY-MM-DD'
						),
						listData: response?.data,
					})
				);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleProductionPlanClose = async (ppId) => {
		const id =
			typeof ppId === 'string' || typeof ppId === 'number'
				? ppId
				: undefined;

		if (modeName === 'longTermProduction') {
			if (id !== undefined && id !== '') {
				const refreshRes =
					await productionPlanServices.getLongTermProductionPlan({
						params: { id: state?.planId },
					});
				if (refreshRes?.statusCode === 200) {
					const { headers, rows, initialState } =
						transformLongTermPlanApiResponse(
							refreshRes.data,
							productList,
							batches
						);
					setTableData({ headers, rows });
					dispatch({
						type: 'SET_STATE',
						payload: {
							...initialState,
							generatedPlans: refreshRes?.data?.generatedPlans,
						},
					});
				}
			}
		} else {
			if (id !== undefined && id !== '') {
				const dateParam = state?.expectedDeliveryDate
					? `&dateRange=${encodeURIComponent({
						active: true,
						from: state.expectedDeliveryDate,
						to: state.expectedDeliveryDate,
					})}`
					: '';
				const url = `${urls?.EXTENSION}${urls?.PRODUCTION_PLANS
					}?id=${encodeURIComponent(id)}${dateParam}`;
				window.open(url, '_blank');
				handleClose();
			} else {
				console.log('production plan id is not generated ');
				handleClose();
			}
		}
	};

	// Check if production plan button should be disabled (expected delivery date is before today)
	const disableProductionPlanBtn = (expectedDeliveryDate) => {
		if (!expectedDeliveryDate) return false;
		const today = moment().startOf('day');
		const deliveryDate = moment(expectedDeliveryDate).startOf('day');
		return deliveryDate.isBefore(today);
	};

	const renderBtns = () => {
		// Use editModeButtons if in edit mode and available
		const buttonsConfig =
			(editMode || orderwise) && mode?.editModeButtons
				? mode.editModeButtons
				: mode?.buttons;

		const filteredButtons = buttonsConfig?.filter((btn) => {
			if (btn.show !== undefined) {
				return state.currentStep > btn.show;
			}
			return true;
		});

		let leftButtons = [];
		let rightButtons = [];
		const isPositionButtons = buttonsConfig?.find((btn) => btn.position);
		if (isPositionButtons) {
			leftButtons =
				filteredButtons?.filter((btn) => btn.position === 'left') || [];
			rightButtons =
				filteredButtons?.filter((btn) => btn.position !== 'left') || [];
		}

		const renderButton = (btn) => {
			const config = buttonConfig?.[btn.id];
			const isProductionPlanBtn = btn.id === 'generateProductionPlan';
			const isDisabledByDate =
				isProductionPlanBtn &&
				disableProductionPlanBtn(state?.expectedDeliveryDate);
			return (
				<Button
					key={btn.id}
					className={`${btn.style}`}
					variant={btn.type}
					disabled={
						config?.getDisabled?.({
							state,
							tableData,
							originalRowsRef,
						}) || isDisabledByDate
					}
					onClick={() =>
						config?.onClick?.({
							state,
							tableData,
							setConfirmationModal,
							lists,
							handleClose,
							proceedGenerateProductionPlan,
							editMode,
							ppId,
							selectedPOs,
							changeQtyRef,
							prevTableData,
							setTableData,
							dispatch,
							setPrevTableData,
							prevTableData,
							productList,
							batches,
							originalRowsRef,
							setSearchQuery,
							workerAllocations,
							setWorkerAllocations,
							orderwise,
						})
					}
				>
					{btn?.icon &&
						iconMap[btn.icon] &&
						(() => {
							const IconComponent = iconMap[btn.icon];
							return <IconComponent className='w-4 h-4 mr-1' />;
						})()}
					{(() => {
						let label = btn.id === 'nextStep' &&
							modeName === 'longTermProduction' &&
							state?.currentStep === 3
							? 'Save Plan'
							: btn?.noDefineLabel
								? btn?.label
								: editMode || orderwise
									? `Edit ${btn.label}`
									: `Create ${btn.label}`;

						// Custom label replacement based on orderType
						if (state?.orderType) {
							const type = String(state.orderType).toUpperCase();
							if (type === 'PO') {
								label = label.replace('Sales Order', 'Secondary Dispatch Order / PO');
							} else if (type === 'CMS') {
								label = label.replace('Sales Order', 'Primary Dispatch Order / CMS');
							}
							return label;
						}
						return label;
					})()}
				</Button>
			);
		};

		return (
			<div className='w-full flex flex-col gap-2'>
				{disableProductionPlanBtn(state?.expectedDeliveryDate) &&
					modeName === 'order' && (
						<p className='w-full flex justify-end text-red-500 text-[12px]'>
							Can't generate production plan: Expected delivery
							date is before order date.
						</p>
					)}
				<div
					className={
						mode?.buttonContainerClass ||
						'w-full flex justify-center gap-2'
					}
				>
					{/* Left positioned buttons */}
					{isPositionButtons ? (
						<>
							<div className='flex gap-2 '>
								{leftButtons.map(renderButton)}
							</div>
							<div className='flex gap-2 '>
								{rightButtons.map(renderButton)}
							</div>
						</>
					) : (
						filteredButtons?.map(renderButton)
					)}
				</div>
			</div>
		);
	};

	const handleOpenProductionPlanModal = (data) => {
		productionPlanModal(
			modalActions?.toggleProductionPlanModal(true, {
				storeId: data?.storeId,
				date: moment(data?.date).format('YYYY-MM-DD'),
				listData: data?.data,
				lppId: state?.planId,
				shiftDistribution: data?.shiftDistribution,
				hideButtons: data?.hideButtons,
				nonEditable: data?.nonEditable,
			})
		);
	};
	const handleOpenModal = () => {
		setIsAddProductModalOpen(true);
	};

	const handleAddProduct = (newProductsData) => {
		const newRows = newProductsData.map((data, index) => {
			const { product, quantity, batch, selectedDays } = data;
			const originalUnit = product.unit || 'gm';
			const newRowIdx = tableData.rows.length + index;

			const newRow = {
				'S.No': newRowIdx + 1,
				productName: product.viewOnlyLabel,
				clientVariantId: product.clientVariantId || '',
				unit: getHigherUnitName(originalUnit) || originalUnit,
				qty: String(quantity),
				batch: batch,
				originalUnit: originalUnit,
				_variantId: product.variantId,
				_productId: product.productId,
				_isManuallyAdded: true,
				planned: quantity,
				finalProduction: quantity,
				variance: 0,
				fulfilledQty: 0,
				Actions: { rowIndex: newRowIdx },
			};

			// Initialize all dates to false, then distribute quantity using batch-aware logic
			const selectedDateIds = selectedDays || [];
			const selectedDateCount = selectedDateIds.length;
			const totalQty = quantity;
			const batchSize = parseFloat(batch) || 0;
			const unit = (product.unit || 'gm').toLowerCase();

			tableData.headers.forEach((h) => {
				if (String(h.id).startsWith('date_')) {
					newRow[h.id] = false;
				}
			});

			if (selectedDateCount > 0) {
				if (batchSize > 0) {
					const numFullBatches = Math.floor(totalQty / batchSize);
					const remainder = totalQty - numFullBatches * batchSize;

					const baseBatchesPerDay = Math.floor(numFullBatches / selectedDateCount);
					let extraBatches = numFullBatches % selectedDateCount;

					selectedDateIds.forEach((key, index) => {
						let dailyQty = baseBatchesPerDay * batchSize;
						if (extraBatches > 0) {
							dailyQty += batchSize;
							extraBatches--;
						}
						if (index === selectedDateCount - 1) {
							dailyQty += remainder;
						}
						newRow[key] = dailyQty;
					});
				} else {
					let qtyPerDate = totalQty / selectedDateCount;
					if (['count', 'pc', 'pcs'].includes(unit)) {
						qtyPerDate = Math.floor(qtyPerDate);
					}
					selectedDateIds.forEach((key) => {
						newRow[key] = qtyPerDate;
					});
				}
			}

			return newRow;
		});

		setTableData({
			...tableData,
			rows: [...tableData.rows, ...newRows],
		});
		setIsAddProductModalOpen(false);
		notificationServices.generateNotification({
			type: 'success',
			message: `${newRows.length} product(s) added to plan. Please Save the plan before generating the production plan.`,
		});
		changeQtyRef.current = false;
	};

	return (
		<BaseModal
			{...(modeName !== 'longTermProduction'
				? {
					heading: viewMode
						? `View ${mode?.heading || 'Multiple PO'}`
						: `${editMode || orderwise ? 'Edit' : 'Create'} ${mode?.heading || 'Multiple PO'
						}`,
				}
				: {
					customHeading: () => (
						<Heading
							mode={
								viewMode
									? 'View'
									: (editMode || orderwise)
										? 'Edit'
										: 'Create'
							}
							currentStep={state?.currentStep}
							title={mode?.heading}
							stepper={
								editMode
									? mode?.editModeStepper
									: mode?.defaultSteps
							}
						/>
					),
				})}
			open={openModal}
			handleClose={handleClose}
			renderBtns={viewMode ? () => { } : renderBtns}
			width='100%'
			height='100%'
			customStyles={{
				...((editMode || viewMode) && {
					background: 'rgb(255 254 248)',
				}),
			}}
			disableBackdropClick
			disableEscapeKeyDown
		>
			<AddProductModal
				isOpen={isAddProductModalOpen}
				onClose={() => setIsAddProductModalOpen(false)}
				onAdd={handleAddProduct}
			/>
			<ProductionPlanModal onCloseModal={handleProductionPlanClose} />
			<CustomModal />
			<ConfirmationModal
				isOpen={confirmationModal?.isOpen}
				heading={confirmationModal.heading}
				message={confirmationModal.message}
				onClose={confirmationModal?.handleCloseConfirmation}
				onConfirm={confirmationModal?.handleConfirmSave}
				isAlert={confirmationModal?.isAlert}
				alertType={confirmationModal?.alertType}
				customButton={confirmationModal?.customButton}
				showCrossBtn={confirmationModal?.showCrossBtn}
				isLoading={confirmationModal?.isLoading}
				width={confirmationModal?.width}
			/>
			<MultiPoContent
				fields={mode?.fields}
				mode={mode}
				modeName={modeName}
				setConfirmationModal={setConfirmationModal}
				handleOpenProductionPlanModal={handleOpenProductionPlanModal}
				handelOpenModal={handleOpenModal}
			/>
		</BaseModal>
	);
};
export default BaseMultipleModal;
